import { render } from "./WidgetDocumotoLogo.vue?vue&type=template&id=3c326b7a"
import script from "./WidgetDocumotoLogo.vue?vue&type=script&lang=js"
export * from "./WidgetDocumotoLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__